import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";
import Swal from "sweetalert2";
import { useHistory } from "react-router";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  RefreshToken: "[Refresh Token] Action",
};

const initialAuthState = {
  user: undefined,
  token: undefined,
};

export const reducer = persistReducer(
  { storage, key: "v726-demo1-auth", whitelist: ["token"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { token } = action.payload;

        return { token, user: undefined };
      }

      case actionTypes.Register: {
        const { token } = action.payload;

        return { token, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.RefreshToken: {
        const { token, user } = action.payload;

        return { token, user };
      }

      default:
        return state;
    }
  }
);

export const selectUser = (state) => state.auth.user.data;
export const selectMe = (state) => state.auth.user.data;

export const selectFormatDate = (state) =>
  state.auth.user.data.active_dateformat === null
    ? "MM/DD/YYYY"
    : state.auth.user.data.active_dateformat;

export const selectPagination = (state) =>
  state.auth.user.data.active_pagination === null
    ? 20
    : parseInt(state.auth.user.data.active_pagination);

    export const selectCoBranding = (state) =>
    state.auth.user.data.co_branding === null || state.auth.user.data.co_branding === ""
      ? "/media/logos/Logo.png"
      : state.auth.user.data.co_branding;

    export const selectDigitGrouping = (state) =>
  state.auth.user.data.digitgrouping === null
    ? "."
    : state.auth.user.data.digitgrouping;


export const actions = {
  login: (token) => ({ type: actionTypes.Login, payload: { token } }),
  register: (token) => ({
    type: actionTypes.Register,
    payload: { token },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  refreshToken: (token, user) => ({
    type: actionTypes.RefreshToken,
    payload: { token, user},
  }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();

    yield put(actions.fulfillUser(user));

    if (user.error === "30012") {
      showInfoDialog(user);
    }
  });
}

const showInfoDialog = async (user) => {
  await Swal.fire({
    width: "80%",
    customClass: "swal-terms-container",
    html: user.message,
    input: "checkbox",
    allowOutsideClick: false,
    inputValue: 0,
    inputPlaceholder: "Please Check Approval Stages",
    confirmButtonText: "Go to APPROVAL STAGES menu",
    inputValidator: (result) => {
      return !result && "You need to Go to APPROVAL STAGES menu";
    },
  }).then((result) => {
    if (result.isConfirmed) {
      window.location = `/administration/approval/stages`;
    }
  });
};
